module.exports = __webpack_public_path__ + "static/media/science2096-2.1990d06c.png";